import React from 'react';
import { Box, LinearProgress } from '@mui/material';
import './footerContent.css';

const FOOTER_PRIMARY = 'var(--sap-sidebar)';

function FooterContent({ title, loading }) {
  // console.log("FooterContent loading prop:", loading);
  return (
    <Box className="sap-footer-content" sx={{ position: 'relative', backgroundColor: FOOTER_PRIMARY, color: 'white', width: '100%' }}>
    {loading && <LinearProgress sx={{ width: '100%', position: 'absolute', top: 0, left: 0, zIndex: 1000 }} />}
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
      {/* <Typography sx={{ margin: 0, color: 'white', fontSize: '1.0em' }} variant="h3">
        {title}
      </Typography> */}

      <h3 style={{ margin: 0, color: 'white',fontSize: '1.0em' }}>{title}</h3>
    </Box>
    {loading && <LinearProgress sx={{ width: '100%', height: '4px', position: 'absolute', bottom: 0, left: 0 }} />}
  </Box>
  );
}

export default FooterContent;

